(function () {
  function activate(root, index) {
    console.log('[pdp-tabs] activate called, index:', index);
    const buttons = root.querySelectorAll('[data-pdp-tab-btn]');
    const panels = root.querySelectorAll('[data-pdp-tab-panel]');
    buttons.forEach((btn, i) => {
      const on = i === index;
      btn.classList.toggle('active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
      btn.setAttribute('tabindex', on ? '0' : '-1');
    });
    panels.forEach((panel, i) => {
      panel.classList.toggle('active', i === index);
      panel.toggleAttribute('hidden', i !== index);
    });
  }

  function init(root) {
    if (!root || root.dataset.pdpTabsInit === 'true') return;
    root.dataset.pdpTabsInit = 'true';
    console.log('[pdp-tabs] init called on root:', root);

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-pdp-tab-btn]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      const buttons = [...root.querySelectorAll('[data-pdp-tab-btn]')];
      const idx = buttons.indexOf(btn);
      console.log('[pdp-tabs] tab button clicked, idx:', idx);
      if (idx < 0) return;
      activate(root, idx);
    });

    root.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const buttons = [...root.querySelectorAll('[data-pdp-tab-btn]')];
      const i = buttons.findIndex((b) => b.classList.contains('active'));
      if (i < 0) return;
      const next =
        e.key === 'ArrowRight'
          ? Math.min(buttons.length - 1, i + 1)
          : Math.max(0, i - 1);
      if (next !== i) {
        e.preventDefault();
        buttons[next].focus();
        activate(root, next);
      }
    });
  }

  document.querySelectorAll('[data-pdp-tabs]').forEach(init);

  // Handle anchor links pointing to #pdp-reviews-tab
  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a[href]');
    if (!anchor) return;
    const hash = anchor.getAttribute('href');
    console.log('[pdp-tabs] anchor clicked, href:', hash);

    if (hash !== '#pdp-reviews-tab') {
      console.log('[pdp-tabs] not a reviews tab anchor, skipping');
      return;
    }

    console.log('[pdp-tabs] reviews tab anchor detected, looking for [data-reviews-tab]');
    const target = document.querySelector('[data-reviews-tab]');
    console.log('[pdp-tabs] target button found:', target);

    if (!target) {
      console.warn('[pdp-tabs] no element with [data-reviews-tab] found — did you add the attribute to the button in liquid?');
      return;
    }

    const root = target.closest('[data-pdp-tabs]');
    console.log('[pdp-tabs] root found:', root);
    if (!root) {
      console.warn('[pdp-tabs] could not find [data-pdp-tabs] ancestor');
      return;
    }

    const buttons = [...root.querySelectorAll('[data-pdp-tab-btn]')];
    const idx = buttons.indexOf(target);
    console.log('[pdp-tabs] activating tab index:', idx, '| all buttons:', buttons.map(b => b.textContent.trim()));
    if (idx < 0) {
      console.warn('[pdp-tabs] target button not found in buttons list');
      return;
    }

    activate(root, idx);
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();